
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/region/facility/[sido]/[sigungu]",
      function () {
        return require("private-next-pages/region/facility/[sido]/[sigungu].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/region/facility/[sido]/[sigungu]"])
      });
    }
  